/* eslint-disable no-console */
const swUrl = `./service-worker.js`;

export const register = () => {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    globalThis.addEventListener('load', async () => {
      try {
        const registration = await navigator.serviceWorker.register(swUrl);

        console.log(`Service Worker registered! Scope: ${registration.scope}`);
      } catch (error) {
        console.error(`Service Worker registration failed: ${error}`);
      }
    });
  }
};

export const unregister = () => {
  if (!('serviceWorker' in navigator)) return;

  navigator.serviceWorker.getRegistrations().then((registrations) => {
    if (!registrations.length) return;

    Promise.all(
      registrations.map((registration) => registration.unregister())
    ).then(() => {
      if (!sessionStorage.getItem('sw-cleanup-reloaded')) {
        sessionStorage.setItem('sw-cleanup-reloaded', 'true');
        globalThis.location.reload();
      }
    });
  });
};
